/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Platforms_Product_CountInputs */

const en_directory_platforms_product_count = /** @type {(inputs: Directory_Platforms_Product_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} products in the directory`)
};

const zh_directory_platforms_product_count = /** @type {(inputs: Directory_Platforms_Product_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`目录中有 ${i?.count} 个产品`)
};

/**
* | output |
* | --- |
* | "{count} products in the directory" |
*
* @param {Directory_Platforms_Product_CountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_platforms_product_count = /** @type {((inputs: Directory_Platforms_Product_CountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Platforms_Product_CountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_platforms_product_count(inputs)
	return zh_directory_platforms_product_count(inputs)
});
export { directory_platforms_product_count as "directory.platforms.product_count" }